import { ANTIFORGERY_BASE_URL } from 'Frontend/constants/endpoint'
import { IAntiforgeryToken } from '../models/general.model'

export async function getAntiforgeryToken(): Promise<IAntiforgeryToken> {
  let response = await fetch(`${ANTIFORGERY_BASE_URL}/getcsrftoken`)

  const jsonResults = await response.json()
  return <IAntiforgeryToken>jsonResults
}
